import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../config";

const headers = () => ({ "X-Admin-Token": localStorage.getItem("admin_token") || "" });
const LABEL = { pending: "Čaká", approved: "Zverejnená", rejected: "Zamietnutá" };
const ERR = { no_preview: "Najprv nahraj náhľad dizajnu pri dopyte", no_website: "Zákazník nemá uvedený web", not_allowed: "Recenzia nie je zverejnená alebo chýba súhlas" };

const FeatureBox = ({ r, onChange }) => {
  const [pid, setPid] = useState(r.previews.at(-1)?.id || "");
  const add = async () => {
    try {
      await axios.post(`${API}/admin/web-reviews/${r.id}/feature`, { preview_id: pid }, { headers: headers() });
      onChange(true); toast.success("Web je medzi referenciami na stránke Tvorba webu");
    } catch (e) { toast.error(ERR[e.response?.data?.detail] || "Pridanie zlyhalo"); }
  };
  const remove = async () => {
    try { await axios.delete(`${API}/admin/web-reviews/${r.id}/feature`, { headers: headers() }); onChange(false); toast.success("Odstránené z referencií"); }
    catch { toast.error("Odstránenie zlyhalo"); }
  };
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2" data-testid={`web-review-feature-${r.id}`}>
      {r.previews.length > 1 && <select value={pid} onChange={(e) => setPid(e.target.value)} className="border border-gray-300 rounded px-2 py-1 text-xs bg-white text-gray-900" data-testid={`web-review-feature-preview-${r.id}`}>
        {r.previews.map((p, i) => <option key={p.id} value={p.id}>{p.caption || `Náhľad ${i + 1}`}</option>)}</select>}
      <button onClick={add} className="text-xs px-2 py-1 rounded bg-blue-600 text-white" data-testid={`web-review-feature-add-${r.id}`}>{r.featured ? "Aktualizovať referenciu" : "Pridať medzi referencie"}</button>
      {r.featured && <button onClick={remove} className="text-xs px-2 py-1 rounded bg-gray-200 text-gray-900" data-testid={`web-review-feature-remove-${r.id}`}>Odstrániť z referencií</button>}
      {r.featured && <span className="text-xs text-emerald-700">✓ v referenciách</span>}
    </div>
  );
};

export const WebReviewsPanel = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { axios.get(`${API}/admin/web-reviews`, { headers: headers() }).then((r) => setRows(r.data.rows)).catch(() => {}); }, []);
  const set = async (id, status) => {
    try {
      await axios.put(`${API}/admin/web-reviews/${id}`, { status }, { headers: headers() });
      setRows((rs) => rs.map((r) => (r.id === id ? { ...r, status, featured: status === "approved" && r.featured } : r)));
      toast.success(status === "approved" ? "Recenzia je zverejnená na stránke Tvorba webu" : "Uložené");
    } catch { toast.error("Zmena zlyhala"); }
  };
  return (
    <div className="border border-gray-200 rounded-lg bg-white p-4" data-testid="web-reviews-panel">
      <p className="font-bold text-gray-900 mb-2">Recenzie webov ({rows.length})</p>
      {rows.length === 0 ? <p className="text-sm text-gray-500">Zatiaľ žiadne recenzie. Žiadosť o recenziu odchádza 7 dní po spustení webu.</p> : (
        <ul className="space-y-3">{rows.map((r) => (
          <li key={r.id} className="border-t border-gray-100 pt-3 text-sm" data-testid={`web-review-row-${r.id}`}>
            <p className="text-gray-900"><b>{"★".repeat(r.rating)}{"☆".repeat(5 - r.rating)}</b> · {r.author}{r.company ? ` · ${r.company}` : ""} · <span className="text-gray-500">{r.email}</span></p>
            <p className="mt-1 text-gray-700">„{r.text}“</p>
            <p className="mt-1 text-xs text-gray-500">{r.consent_reference ? `Súhlas so zaradením do referencií: áno (${r.website || "web neuvedený"})` : "Súhlas so zaradením do referencií: nie"} · Stav: {LABEL[r.status]}</p>
            <div className="mt-2 flex gap-2">
              <button onClick={() => set(r.id, "approved")} disabled={r.status === "approved"} className="text-xs px-2 py-1 rounded bg-emerald-600 text-white disabled:opacity-40" data-testid={`web-review-approve-${r.id}`}>Zverejniť</button>
              <button onClick={() => set(r.id, "rejected")} disabled={r.status === "rejected"} className="text-xs px-2 py-1 rounded bg-gray-200 text-gray-900 disabled:opacity-40" data-testid={`web-review-reject-${r.id}`}>Zamietnuť</button>
            </div>
            {r.status === "approved" && r.consent_reference && <FeatureBox r={r} onChange={(featured) => setRows((rs) => rs.map((x) => (x.id === r.id ? { ...x, featured } : x)))} />}
          </li>))}</ul>)}
    </div>
  );
};
